interface VimeoEmbedProps {
  url: string;
  title?: string;
}

export const VimeoEmbed = ({ url, title = "Training Video" }: VimeoEmbedProps) => {
  // Extract video ID from various Vimeo URL formats
  const getVideoId = (vimeoUrl: string): string | null => {
    const patterns = [
      /vimeo\.com\/(\d+)/,
      /player\.vimeo\.com\/video\/(\d+)/,
    ];
    
    for (const pattern of patterns) {
      const match = vimeoUrl.match(pattern);
      if (match) return match[1];
    }
    return null;
  };

  const videoId = getVideoId(url);
  
  if (!videoId) return null;

  return (
    <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-muted">
      <iframe
        src={`https://player.vimeo.com/video/${videoId}?badge=0&autopause=0&player_id=0&app_id=58479`}
        title={title}
        className="absolute inset-0 w-full h-full"
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
        allowFullScreen
      />
    </div>
  );
};
